import { render, staticRenderFns } from "./SettingsUpdates.vue?vue&type=template&id=39f936ca&scoped=true"
import script from "./SettingsUpdates.vue?vue&type=script&lang=js"
export * from "./SettingsUpdates.vue?vue&type=script&lang=js"
import style0 from "./SettingsUpdates.vue?vue&type=style&index=0&id=39f936ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f936ca",
  null
  
)

export default component.exports